// ALN-1871 iOS Safari's native time picker only exposes hours and minutes, but keeps
// whatever seconds were in the original value. Picking the current minute can then
// produce a time a few seconds in the future, which the collector rejects as invalid.
// When the chosen time falls in the current minute but is ahead of now, use now instead.
export const buildTimeFromInput = (baseDate, inputValue, now) => {
  const [hour, minute, second = 0] = inputValue.split(':');
  const time = new Date(baseDate.getTime());
  time.setHours(Number(hour), Number(minute), Number(second));

  const isSameMinute =
    time.getFullYear() === now.getFullYear() &&
    time.getMonth() === now.getMonth() &&
    time.getDate() === now.getDate() &&
    time.getHours() === now.getHours() &&
    time.getMinutes() === now.getMinutes();

  if (isSameMinute && time > now) return new Date(now.getTime());
  return time;
};
